import React, { useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { PositionIcon } from '../../constants/icons';
import './CurrentLocationButton.css';

/**
 * CurrentLocationButton Component
 * Provides geolocation functionality to center map on user's current position
 */
function CurrentLocationButton() {
  const map = useMap();
  const markerRef = useRef(null);

  const handleClick = () => {
    if (!navigator.geolocation) {
      alert("Geolocalizzazione non supportata dal tuo browser");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        
        // Fly to user's location
        map.flyTo([latitude, longitude], 18);

        // Remove existing marker if present
        if (markerRef.current) {
          map.removeLayer(markerRef.current);
        }

        // Create custom icon
        const icon = L.icon({
          iconUrl: require("leaflet/dist/images/marker-icon.png"),
          iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
          shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41],
        });

        // Add new marker
        const newMarker = L.marker([latitude, longitude], { icon })
          .addTo(map)
          .bindPopup("Sei qui")
          .openPopup();

        markerRef.current = newMarker;
      },
      (error) => {
        console.error("Error getting location:", error);
        let errorMessage = "Impossibile ottenere la tua posizione.";
        
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = "Permesso per la geolocalizzazione negato.";
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = "Posizione non disponibile.";
            break;
          case error.TIMEOUT:
            errorMessage = "Timeout nella richiesta di geolocalizzazione.";
            break;
          default:
            break;
        }
        
        alert(errorMessage);
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      }
    );
  };

  return (
    <button
      onClick={handleClick}
      title="Vai alla mia posizione"
      className="current-location-button"
      aria-label="Vai alla mia posizione"
    >
      <img src={PositionIcon} alt="Current location" />
    </button>
  );
}

export default CurrentLocationButton;
